<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="drawer"
    :src="image"
    app
    color="grey darken-2"
    mobile-break-point="960"
    dark
    floating
    persistent
    width="260"
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template>
    <v-list-item two-line>
      <v-list-item-avatar color="white">
        <v-img
          :src="logo"
          height="40"
          contain
        />
      </v-list-item-avatar>
      <v-list-item-title class="title">
        Workspace
      </v-list-item-title>
    </v-list-item>

    <v-divider class="mx-4 mb-4" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-group   
        :value="expand"         
        no-action
        color="white"
      >
        <template
          v-slot:activator
        >
          <v-list-item-avatar
            color="white"            
          >
            <v-img
              :src="employee.thumbnail_url"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="white--text caption">
              {{ user.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="link in profileLinks"
          :key="link.title"
          :to="link.to"
          :active-class="color"
          class="v-list-item"
          style="padding-left: 15px;"
        >
          <v-list-item-action>
            <v-icon>{{ link.action }}</v-icon>
          </v-list-item-action>
          <v-list-item-title
            class="caption"
            v-text="
              link.title"
          />
        </v-list-item>
      </v-list-group>
    </v-list>

    <v-divider class="mx-4 mt-4" />

    <v-list class="py-2">
      <v-list-group
        v-for="(linkGroup,i) in filteredGroups"
        :key="linkGroup.title"
        :value="subExpand"
        color="white"
      >
        <template
          v-slot:activator
        >
          <v-list-item-action>
            <v-icon>{{ linkGroup.action }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-subtitle class="white--text caption">
              {{ linkGroup.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <div
          :id="'navVlist'+i"          
        >         
          <v-list-item
            v-for="(link, i) in linkGroup.links"
            :key="i"
            :to="link.to"
            :active-class="color"
            class="adsasd"
            :class="{
              'no-pm': link.subLinks
            }"
          >
            <v-list-group
              v-if="link.subLinks"
              :key="link.title"
              :value="deepExpand"
              sub-group
              class="sub-no-pl"
              color="white"
            >
              <template v-slot:activator>
                <v-list-item-title
                  class="caption"
                >
                  {{ link.title }}
                </v-list-item-title>

                <v-list-item-action v-if="link.batchKey">
                  <v-avatar
                    color="primary"
                    small
                    size="25"
                  >
                    <span class="caption">{{ getBatchNumber(link.batchKey) }}</span>
                  </v-avatar>
                </v-list-item-action>
              </template>
              <v-list-item
                v-for="(subLink, j) in link.subLinks"          
                :key="j"
                :to="subLink.to"
                :active-class="color"
                style="padding-left:70px"
              >                
                <v-list-item-title
                  style="max-width: 120px;"
                  class="text-truncate caption"
                >                
                  {{ subLink.title }}
                </v-list-item-title>

                <v-list-item-action v-if="subLink.batchKey">
                  <v-avatar
                    color="primary"
                    small
                    size="25"
                  >
                    <span class="caption">{{ getBatchNumber(subLink.batchKey) }}</span>
                  </v-avatar>
                </v-list-item-action>
              </v-list-item>  
            </v-list-group>

            <v-list-item-title
              v-else
              class="caption"
              style="padding-left: 56px"
            >
              {{ link.title }}
            </v-list-item-title>
          </v-list-item> 
        </div>
      </v-list-group>
    </v-list>   
  </v-navigation-drawer>
</template>

<script>
// Utilities
  import {
    mapMutations,
    mapState,
  } from 'vuex'

  export default {
    data: () => ({
      logo: '/img/rex-tech.png',
      fullPages: [
        '/leave-dashboard',
      ],
      profileLinks: [
        { 
          to: '/profile',
          title: 'My Profile',
          action: 'mdi-account',
          mobileView: true,
        },
        // { 
        //   to: '/my-leave',
        //   title: 'My Leave',
        //   action: 'mdi-calendar-account',
        //   mobileView: false,
        // },
        // {
        //   to: '/my-attendance',
        //   title: 'My Attendance',
        //   action: 'mdi-flag',
        //   mobileView: false,
        // },
        // {
        //   to: '/announcements',
        //   title: 'E-Notice Board',
        //   action: 'mdi-file-document-box',
        //   mobileView: true,
        // },
        // {
        //   to: '/documents',
        //   title: 'Documents & Forms',
        //   action: 'mdi-file-document-box',
        //   mobileView: true,
        // },
        // { 
        //   to: '/my-course',
        //   title: 'My Course',
        //   action: 'mdi-file-document',
        //   mobileView: true,
        // },
        // { 
        //   to: '/my-quality-management',
        //   title: 'Quality Management',
        //   action: 'mdi-file-document',
        //   mobileView: true,
        // },
        // { 
        //   to: '/events',
        //   title: 'Events',
        //   action: 'mdi-account-switch',
        //   mobileView: true,
        // },
        // {
        //   to: '/orgchart',
        //   action: 'mdi-lan',
        //   title: 'Organization Chart',
        //   mobileView: false,
        // },
        // {
        //   to: '/kpichart',
        //   action: 'mdi-cash-usd',
        //   title: 'KPI Chart',
        //   mobileView: false,
        // },
      ],
      linkGroups: [
        {
          action: 'mdi-account-multiple-outline',
          title: 'Organization',
          links: [
            {
              to: '/employees',
              title: 'Employees',
              permission: 'organization employee view',
              mobileView: true,
            },
            {
              to: '/branches',
              title: 'Branches',
              permission: 'setup branch view',
              mobileView: true,
            },
            // {
            //   to: '/leave-dashboard',
            //   title: 'Leave Dashboard',
            //   permission: 'leave dashboard view',
            //   mobileView: false,
            // },
            // {
            //   to: '/attendances',
            //   title: 'Attendance',
            //   mobileView: true,
            //   permission: 'attendance import view',
             
            // },
            // {
            //   title: 'Reports',
            //   subLinks: [
            //     {
            //       to: '/leave-reports',
            //       title: 'Leaves',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/attendance-reports',
            //       title: 'Attendance',
            //       permission: 'attendance report view',
            //       mobileView: true,
            //     },
            //   ],
            // },
            // {
            //   title: 'Approval',
            //   batchKey: 'total',
            //   subLinks: [
            //     {
            //       to: '/leave-applications',
            //       title: 'Leave Approvals',
            //       permission: 'leave application view',
            //       mobileView: false,
            //       batchKey: 'leaves',
            //     },
            //     {
            //       to: '/promises',
            //       title: 'Promise Requests',
            //       permission: 'update promises',
            //       mobileView: true,
            //       batchKey: 'promises',
            //     },
            //     {
            //       to: '/tasks',
            //       title: 'Task Approvals',
            //       mobileView: true,
            //       batchKey: 'tasks',
            //     },
            //   ],
            // },
            // {
            //   to: '/announcements',
            //   title: 'Announcement',
            //   mobileView: false,
            // },
            // {
            //   title: 'Payroll',
            //   subLinks: [
            //     {
            //       to: '/payroll-preparation-summary',
            //       title: 'Payroll Preparation',
            //       mobileView: false,
            //     },
            //   ],
            // },
          ],
        },
        {
          action: 'mdi-settings',
          title: 'Setup',
          links: [
            // {
            //   title: 'Office Location',
            //   to: '/office-locations',
            //   permission: 'setup office location view',
            // },
            {
              title: 'Company',
              subLinks: [
                {
                  to: '/company-banks',
                  title: 'Banks',
                  permission: 'setup company bank view',
                },
              ], 
            },
            // {
            //   title: 'Award',
            //   subLinks: [
            //     {
            //       to: '/awards',
            //       title: 'Awards',
            //       permission: 'setup award view',
            //       mobileView: true,
            //     },
            //   ],
            // },
            // {
            //   title: 'Career',
            //   subLinks: [
            //     {
            //       to: '/job-descriptions',
            //       title: 'Job Descriptions',
            //       permission: 'setup job description view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/position-requirements',
            //       title: 'Job Requirements',
            //       permission: 'setup position job requirement view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/positions',
            //       title: 'Positions',
            //       permission: 'setup position view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/position-categories',
            //       title: 'Position Categories',
            //       permission: 'setup position category view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/ranks',
            //       title: 'Ranks',
            //       permission: 'setup rank view',
            //       mobileView: true,      
            //     },
            //     {
            //       to: '/position-groups',
            //       title: 'Position Groups',
            //       permission: 'setup position group view', 
            //       mobileView: false,
            //     },
            //   ],
            // },            
            {
              title: 'Holiday',
              subLinks: [
                {
                  to: '/holidays',
                  title: 'Holidays',
                  permission: 'setup holiday view',
                  mobileView: true,
                },
                {
                  to: '/holiday-details',
                  title: 'Holidays Details',
                  permission: 'setup holiday view',
                  mobileView: true,
                },
              ],
            },
            // {
            //   title: 'Leave',
            //   subLinks: [
            //     {
            //       to: '/leave-types',
            //       title: 'Types',
            //       permission: 'setup leave type view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/leave-entitlements',
            //       title: 'Entitlements',
            //       permission: 'setup leave entitlement view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/leave-entitlement-settings',
            //       title: 'Entitlement Settings',
            //       permission: 'setup leave entitlement setting view',
            //       mobileView: true,
            //     },
            //   ],
            // },
            {
              title: 'Management',
              subLinks: [
                // {
                //   to: '/departments',
                //   title: 'Departments',
                //   permission: 'setup department view',
                //   mobileView: true,
                // },
                {
                  to: '/roles',
                  title: 'Roles',
                  permission: 'setup role view',
                  mobileView: true,
                },
              ],
            },
            // {
            //   title: 'Skill',
            //   subLinks: [
            //     {
            //       to: '/skill-categories',
            //       title: 'Categories',
            //       permission: 'setup skill category view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/skills',
            //       title: 'Skills',
            //       permission: 'setup skill view',
            //       mobileView: true,        
            //     },
            //   ],
            // },
            // {
            //   title: 'Task',
            //   subLinks: [
            //     {
            //       to: '/task-categories',
            //       title: 'Categories',
            //       permission: 'setup task category view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/task-priorities',
            //       title: 'Priorities',
            //       permission: 'setup task priority view',
            //       mobileView: true,        
            //     },
            //   ],
            // },
            // HRIS
            // {
            //   title: 'Separation',
            //   subLinks: [
            //     {
            //       to: '/separation-types',
            //       title: 'Types',
            //       permission: 'setup separation type view',
            //       mobileView: true,
            //     },
            //   ],
            // },
            // {
            //   title: 'Training',
            //   subLinks: [
            //     {
            //       to: '/classroom-types',
            //       title: 'Classroom Types',
            //       permission: 'setup classroom type view',
            //       mobileView: true,
            //     },               
            //     {
            //       to: '/course-categories',
            //       title: 'Course Categories',
            //       permission: 'setup course category view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/courses',
            //       title: 'Courses',
            //       permission: 'setup course view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/course-material-types',
            //       title: 'Course Material Types',
            //       permission: 'setup course material type view',
            //       mobileView: true,
            //     },
            //   ],
            // },
            {
              title: 'Notification',
              subLinks: [
                {
                  to: '/notification-types',
                  title: 'Notification Types',
                  permission: 'setup notification type view',
                  mobileView: true,
                },               
              ],
            },
            // {
            //   title: 'Attendance',
            //   subLinks: [
            //     {
            //       to: '/attendance',
            //       title: 'Attendance Setting',
            //       permission: 'attendance setting view',
            //       mobileView: false,
            //     },               
            //   ],
            // },
            // HRIS
            // {
            //   title: 'Work Session',
            //   subLinks: [
            //     {
            //       to: '/work-session-types',
            //       title: 'Work Session Type',
            //       permission: 'setup work session types view',
            //       mobileView: false,
            //     },               
            //   ],
            // },
            // {
            //   title: 'Payroll',
            //   subLinks: [
            //     {
            //       to: '/allowance-penalty-types',
            //       title: 'Allowance Types',
            //       mobileView: false,
            //       permission: 'view allowance penalty types',
            //     },
            //     {
            //       to: '/socso',
            //       title: 'Socso Rate',
            //       mobileView: false,
            //       permission: 'setup socso view',
            //     },
            //     {
            //       to: '/eis',
            //       title: 'EIS Rate',
            //       mobileView: false,
            //       permission: 'setup eis view',
            //     },
            //     {
            //       to: '/epf',
            //       title: 'EPF Rate',
            //       mobileView: false,
            //       permission: 'setup epf view',
            //     },
            //     {
            //       to: '/tax-rates',
            //       title: 'Tax Rate',
            //       mobileView: false,
            //       permission: 'tax rate view',
            //     },
            //     {
            //       to: '/tax-reliefs',
            //       title: 'Tax Relief',
            //       mobileView: false,
            //       permission: 'tax relief view',
            //     },
            //     {
            //       to: '/payroll-banks',
            //       title: 'Payroll Banks',
            //       mobileView: false,
            //       permission: 'payroll bank view', 
            //     },
            //   ],
            // },
            // {
            //   title: 'Quality Management',
            //   subLinks: [
            //     {
            //       to: '/quality-managements',
            //       title: 'Quality Management',
            //       permission: 'setup quality management view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/qm-folder',
            //       title: 'QM Folder',
            //       permission: 'setup quality management folder view',
            //       mobileView: true,
            //     },
            //   ],
            // },
            // {
            //   title: 'E-Notice Board',
            //   subLinks: [
            //     {
            //       to: '/announcement-setup',
            //       title: 'Announcements',
            //       permission: 'setup announcement view',
            //       mobileView: true,
            //     },
            //     {
            //       to: '/announcement-categories',
            //       title: 'Categories',
            //       permission: 'setup announcement category view',
            //       mobileView: true,
            //     },
            //   ],
            // },
          ],
        },
      ],
      filteredGroups: [],
      expand: false,
      subExpand: false,
      deepExpand: false,
      batchNumbers: {
        promises: 0,
        leaves: 0,
        total: 0,
        tasks: 0,
      },
    }),
    computed: {
      ...mapState('app', ['image', 'color']),
      ...mapState({ user: 'currentUser', employee: 'currentEmployee' }),
      drawer: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        },
      },
    },
    watch: {
      $route: {
        immediate: true,
        handler (val) {
          if (this.fullPages.includes(val.path)) {
            this.setDrawer(false)
          }
        },
      }, 
    }, 
    created () {   
      this.populateMenus()      
      this.loadData()
    },
    methods: {
      ...mapMutations('app', ['setDrawer']),
      populateMenus () {
        this.linkGroups.map(linkGroup => {
          const links = linkGroup.links.filter(link => {
            if (link.permission) {
              if (this.$vuetify.breakpoint.smAndDown) {
                if (this.$hasPermissionTo([link.permission]) && link.mobileView) return link
              } else {
                if (this.$hasPermissionTo([link.permission])) return link
              }
            } else {
              if (link.subLinks) {
                const subLinks = link.subLinks.filter(subLink => {
                  if (subLink.permission) {
                    if (this.$vuetify.breakpoint.smAndDown) {
                      if (this.$hasPermissionTo([subLink.permission]) && subLink.mobileView) return subLink
                    } else {
                      if (this.$hasPermissionTo([subLink.permission])) return subLink
                    }
                  } else return subLink
                })
                if (subLinks.length < 1) return 
                this.$set(link, 'subLinks', subLinks)
              }
              return link
            }       
          })
          if (links.length < 1) return
          this.$set(linkGroup, 'links', links)
          this.filteredGroups.push(linkGroup)
        })
      },
      loadData () {
        this.$http.all([
          this.$api.promises().pendingCount(),
          this.$api.ownerTasks().pendingTaskCount(this.employee.employee_uid),
          this.$api.ownerTasks().completedTaskCount(this.employee.employee_uid),
          this.$api.assigneeTasks().pendingTaskCount(this.employee.employee_uid),
        ])
          .then(this.$http.spread((promisesCount, ownerPendingTasksCount, ownerCompletedTasksCount, assigneePendingTasksCount) => {
            this.batchNumbers.promises = promisesCount.data
            this.batchNumbers.tasks = ownerPendingTasksCount.data + ownerCompletedTasksCount.data + assigneePendingTasksCount.data

            this.batchNumbers.total += promisesCount.data
            this.batchNumbers.total += ownerPendingTasksCount.data + ownerCompletedTasksCount.data + assigneePendingTasksCount.data
          }))
      },
      getBatchNumber (key) {
        return this.batchNumbers[key]
      },
      
    },
  }
</script>

<style lang="scss">
  #app-drawer {
    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }
  }
  
</style>

<style lang="css" scoped> 

  ::v-deep .sub-no-pl .v-list-item.v-list-group__header {
    width:230px;
  }

  .no-pm{
    margin:unset !important;
    padding: unset !important;
  }
   /* ::v-deep #navVlist0 div.v-list-item:last-child{
    margin:unset !important;
    padding: unset !important;
  } */

</style>
